import React from "react";
import Alerts from "../Alerts";

export default function ErrorAlert(props) {
  if (
    !props ||
    !props.hasOwnProperty("error") ||
    !props.error ||
    props.error.length === 0
  ) {
    return null;
  }

  return props.error.map(function (value, index) {
    return (
      <Alerts
        className="error-log"
        severity="error"
        alertMessage={value}
        key={index}
      />
    );
  });
}
